import Link from "next/link";

export default function Brand() {
  return (
    <Link href='/' className="flex items-center gap-3">
      <img
        className="h-12 scale-130 invert"
        src="/logo.svg"
        alt="FigAI brand logo"
      />
      <h2 className="mt-1.5 text-3xl font-bold text-blue-100">FigAI</h2>
    </Link>
  );
}
